/** Session-scoped trial promo from ?trialPromo= on main SPA URLs (index.jsx / HashRouter). */
export const TRIAL_PROMO_QUERY_PARAM = 'trialPromo';
export const TRIAL_PROMO_SESSION_KEY = 'lyw_trial_promo_code';
export const DEFAULT_TRIAL_MONTHS = 3;

/** Display-only mirror of server allowlist in TrialPromoCodes / TrialPromoHelper. */
const KNOWN_PROMO_MONTHS = {
    SIXMONTHS: 6,
};

function normalizeTrialPromoCode(raw) {
    if (raw == null) return null;
    const trimmed = String(raw).trim();
    if (!trimmed) return null;
    return trimmed.toUpperCase();
}

export function readTrialPromoFromUrl() {
    const fromSearch = new URLSearchParams(window.location.search).get(TRIAL_PROMO_QUERY_PARAM);
    if (fromSearch) return normalizeTrialPromoCode(fromSearch);

    const hash = window.location.hash || '';
    const qIndex = hash.indexOf('?');
    if (qIndex >= 0) {
        const fromHash = new URLSearchParams(hash.slice(qIndex + 1)).get(TRIAL_PROMO_QUERY_PARAM);
        if (fromHash) return normalizeTrialPromoCode(fromHash);
    }

    return null;
}

export function captureTrialPromoFromUrl() {
    const code = readTrialPromoFromUrl();
    if (code && typeof sessionStorage !== 'undefined') {
        sessionStorage.setItem(TRIAL_PROMO_SESSION_KEY, code);
    }
    return code;
}

export function getSessionTrialPromoCode() {
    captureTrialPromoFromUrl();
    if (typeof sessionStorage === 'undefined') return null;
    return sessionStorage.getItem(TRIAL_PROMO_SESSION_KEY);
}

export function getSessionTrialDisplayMonths() {
    const code = getSessionTrialPromoCode();
    if (!code) return DEFAULT_TRIAL_MONTHS;
    return KNOWN_PROMO_MONTHS[code] ?? DEFAULT_TRIAL_MONTHS;
}

export function appendTrialPromoToBeginOrder(c167) {
    const promo = getSessionTrialPromoCode();
    if (promo) {
        c167.C167_TrialPromoCode = promo;
    }
    return c167;
}
